import { useState } from 'react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import EFArrowRight from '@/components/UI/svg/Icons/EFArrowRight';
import { videoMap, learnMoreMap, LocaleTypes } from '@/config/whole-home-backup-power-solution';
import EFVideoModal from '@/components/UI/EFVideoModal';
import EFPic from '@/components/UI/EFPic';
import EFNPlay from '@/components/UI/svg/LandingPage/EFNPlay';

export default function O(): JSX.Element {
    const { useLang, useRouter, gtm } = useGlobal();
    const { locale } = useRouter();
    const { t } = useLang('landingPage');
    const videoList = videoMap[locale as LocaleTypes] || [];
    const learnMoreList = learnMoreMap[locale as LocaleTypes] || [];
    const [videoSource, setVideoSource] = useState('');
    const [showEFVideoModal, setShowEFVideoModal] = useState(false);

    const handleLearMore = (item: any) => {
        try {
            // GA埋点
            gtm.push({
                event: 'uaEvent',
                event_name: 'solution_button',
                list_name: t(item.title),
                button_name: t('learn_more'),
            });
            // fb埋点
            // window?.fbq && window?.fbq('track', 'Search');
        } catch (e) {
            console.log(e);
        }
        window.open(item?.link, '_blank');
    };

    return (
        <div className={`landing_page_O ${css.landing_page_O}`}>
            <div className="video-wrapper">
                <div className="title">{t('secO_title')}</div>
                <div className="desc">{t('secO_desc')}</div>
                <div className="video-list">
                    {videoList.map((item, index) => (
                        <div
                            className="video"
                            key={index}
                            onClick={() => {
                                try {
                                    // GA埋点
                                    gtm.push({
                                        event: 'uaEvent',
                                        event_name: 'video',
                                        title_name: t(item.desc),
                                        position: `Solution Page_${index + 1}`,
                                    });
                                    // fb埋点
                                    // window?.fbq && window?.fbq('track', 'Search');
                                } catch (e) {
                                    console.log(e);
                                }
                                setVideoSource(item.source);
                                setShowEFVideoModal(true);
                            }}
                        >
                            <div className="video-img-box">
                                <EFPic src={item.poster} className="video-img" />
                                <div className="mask"></div>
                                <EFNPlay className="video-play-icon" />
                            </div>
                            <div className="video-desc">{t(item.desc)}</div>
                        </div>
                    ))}
                </div>
            </div>
            <div className="learn-more-wrapper">
                <div className="left">
                    <div className="title">{t(learnMoreList[0]?.title)}</div>
                    <div className="desc">{t(learnMoreList[0]?.desc)}</div>
                    <div className="learn-more" onClick={() => handleLearMore(learnMoreList[0])}>
                        <span className="link_more">{t('learn_more')}</span>
                        <EFArrowRight height="16px" width="16px" color="#2673ff" />
                    </div>
                </div>
                <div className="right">
                    <div className="title">{t(learnMoreList[1]?.title)}</div>
                    <div className="desc">{t(learnMoreList[1]?.desc)}</div>
                    <div className="learn-more" onClick={() => handleLearMore(learnMoreList[1])}>
                        <span className="link_more">{t('learn_more')}</span>
                        <EFArrowRight height="16px" width="16px" color="#2673ff" />
                    </div>
                </div>
            </div>
            {videoSource && showEFVideoModal && (
                <EFVideoModal
                    visible={showEFVideoModal}
                    source={videoSource}
                    onClose={() => setShowEFVideoModal(false)}
                    playerType={locale === 'cn' ? 'Alibaba' : 'YouTube'}
                />
            )}
        </div>
    );
}
